import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { panLookUp } from "../../../../../redux/features/sharedResources/sharedResources";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";
import {
  resetPanArchived,
  resetPanUnarchived,
} from "../../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import PanDetails from "../../../../../components/_utils/AccountCreationComponents/PanDetails";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import ActiveInactiveAssociatePopup from "../../../../../components/_utils/ActiveInactiveAssociatePopup";

const FieldForceAccountPanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  setAccountType,
  type,
  previousId,
  setIsActive,
  beneLookError,
  isBankLinkedToThisPan,

  hideBlock,
  hideCreate,
  nonArchive,
  setPreviousBankNo,
  isLinkedAccount,

  alreadyLinked,
  setPayload,
  payload,
  setShowAccInfo,
  associatedPan,

  setShowPopup,
  accountData,
  accActiveInactiveState,
  setAccActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  shouldNextBtnBeEnabled,
  id,
  updateActive,
  setHandleUpdateNext,
  handleUpdateNext,
}) => {
  const [isApprovedState, setIsApprovedState] = useState([]);

  const associatedAccountRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Active");
  const dispatch = useDispatch();

  const currentAccount = accountData || {};

  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  useEffect(() => {
    if (activeTab === "Active") {
      setIsActive(false);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    } else if (activeTab === "Inactive") {
      setIsActive(true);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    }
  }, [activeTab]);

  useEffect(() => {
    const ActualPANno = currentAccount?.pan_no;

    if (currentAccount?.id) {
      if (verifiedPan && ActualPANno != panNumber) {
        BenEnableNextButton(false);
      } else {
        BenEnableNextButton(true);
      }
    }
  }, [currentAccount, isLinkedAccount, alreadyLinked, verifiedPan, panNumber]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  const [showDetail, setShowDetail] = useState(null);

  useEffect(() => {
    if (
      !beneLookLoading &&
      !verifyPANisLoading &&
      beneLookError === true &&
      verifiedPan &&
      panNumber?.length === GlobalConfiguration.panLength
    ) {
      setShowDetail(true);
    } else {
      setShowDetail(false);
    }
  }, [
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
    verifiedPan,
    panNumber,
  ]);

  const navigate = useNavigate();
  const {
    unachivedLoadingPan,
    achivedLoadingPan,
    unachivedDataPan,
    achivedDataPan,
  } = useSelector((state) => state.verify);

  useEffect(() => {
    let haveApprovedLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === previousId;
      },
    );

    let haveApprovedNotLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== previousId;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setPreviousBankNo(val?.bank_acc_no);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    if (!achivedLoadingPan) {
      if (achivedDataPan?.status === true) {
        dispatch(panLookUp({ pan_number: panNumber }));

        CommonToast({
          text: "Account archived successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        dispatch(resetPanArchived());
      } else if (achivedDataPan?.status === false) {
        if (achivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(achivedDataPan?.errors)[0][0],
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanArchived());
        }
      }
    }
  }, [achivedDataPan]);

  useEffect(() => {
    if (!unachivedLoadingPan) {
      if (unachivedDataPan?.status === true) {
        dispatch(panLookUp({ pan_number: panNumber }));

        CommonToast({
          text: "Account unarchived successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setAccountType({ type: "", id: "" });
        dispatch(resetPanUnarchived());
      } else if (unachivedDataPan?.status === false) {
        if (unachivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(unachivedDataPan?.errors)[0][0],
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanUnarchived());
        }
      }
    }
  }, [unachivedDataPan]);

  return (
    <div
      className={`w-width-full max-w-tab-width-normal m-auto snap-start flex flex-col justify-center items-center lg:flex-row lg:justify-between lg:items-start lg:gap-gap-xl pb-padding-xl overflow-y-auto overflow-x-hidden `}
    >
      <div
        className={`w-full  px-padding-md lg:px-padding-base  lg:w-width-md ${openAssociatePopup ? "" : "z-z-index-base"}`}
      >
        {(isLinkedAccount || alreadyLinked) &&
        verifiedPan &&
        !beneLookLoading ? (
          <div
            className=" p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md flex  gap-gap-sm items-center
          "
          >
            <img
              className="w-icon-md h-icon-md"
              src={ICONS.ERROR_WITH_WHITE_CIRCLE}
              alt="error_with_white_circle"
            />
            <p className=" text-text-secondary text-font-xs ">
              The bank account is already linked to the PAN provided. To
              proceed, update either the bank details or the PAN associated with
              the profile.
            </p>
          </div>
        ) : nonArchive ? (
          <div className="flex items-center w-width-full h-auto ml-margin-base lg:w-[472px] lg:h-[85px] lg:ml-margin-md py-padding-md px-padding-lg mb-margin-md rounded-[40px] opacity-base-opacity mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="info"
              className="w-[24px] h-[24px] mr-margin-md"
            />
            <p className="w-width-full h-auto lg:w-[368px] lg:h-[60px] text-left text-font-sm font-normal tracking-normal text-text-primary opacity-base-opacity mt-margin-sm">
              Archiving this account is disabled. As you're currently editing
              this account, archiving cannot be performed.
            </p>
          </div>
        ) : hideBlock ? (
          <div className="flex items-center w-width-full max-w-[472px] ml-margin-md py-padding-md px-padding-lg rounded-[40px] opacity-base-opacity mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="info"
              className="w-[24px] h-[24px] mr-margin-md"
            />
            <p className="w-[368px] h-[44px] text-left text-font-md font-normal tracking-normal text-text-primary opacity-base-opacity">
              To unblock this account, please contact customer support
            </p>
          </div>
        ) : hideCreate ? (
          <div className="flex items-center w-width-full max-w-[472px] ml-margin-md py-padding-md px-padding-lg rounded-[40px] opacity-base-opacity mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="info"
              className="w-[24px] h-[24px] mr-margin-md"
            />
            <p className="w-[368px] h-[44px] text-left text-font-md font-normal tracking-normal text-text-primary opacity-base-opacity">
              Creating a new account adds it to the active accounts for the
              provided PAN
            </p>
          </div>
        ) : beneLookData?.status &&
          panNumber?.length === GlobalConfiguration.panLength &&
          verifiedPan &&
          !associatedPan &&
          currentAccount?.pan_no !== panNumber ? (
          <></>
        ) : null}

        <div className="rounded-border-radius-sm h-auto">
          <PanDetails
            verifiedPan={verifiedPan}
            verifyPANisLoading={verifyPANisLoading}
            panNumber={panNumber}
            handlePanChange={handlePanChange}
            panDetails={panDetails}
          />
        </div>
      </div>

      <div
        className={`w-width-full flex flex-col h-auto lg:w-width-md relative Qlg:p-padding-base p-padding-md ${openAssociatePopup ? "" : "z-z-index-base"}`}
      >
        {verifiedPan === true &&
          beneLookLoading === false &&
          verifyPANisLoading === false &&
          shouldNextBtnBeEnabled &&
          !updateActive && (
            <div style={{ overflow: "hidden" }}>
              <div
                className={
                  verifiedPan === false ? "" : "animate-slideInFromRight"
                }
              >
                <ConfirmBtnAccCreation
                  type="pan"
                  status={beneLookData?.status}
                  lookupNext={handleUpdateNext}
                  selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                  not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                  handleClick={() => {
                    setHandleUpdateNext(true);
                  }}
                />
              </div>
            </div>
          )}
        <ActiveInactiveAssociatePopup
          flow={
            verifiedPan === false
              ? "hideAssociate"
              : (isLinkedAccount || alreadyLinked) && verifiedPan
                ? "Existing"
                : showDetail
                  ? "notFoundPan"
                  : !showDetail && verifiedPan
                    ? "Pan"
                    : "defaultPan"
          }
          dropDownNo={GlobalConfiguration?.lengthCheckTwo}
          pan={payload?.panNumber}
          ifsc={isBankLinkedToThisPan?.ifsc_code}
          bank={isBankLinkedToThisPan?.bank_acc_no}
          accActiveInactiveState={accActiveInactiveState}
          setAccActiveInactiveState={setAccActiveInactiveState}
          currentAssociate={currentAssociate}
          setCurrentAssociate={setCurrentAssociate}
          openAssociatePopup={openAssociatePopup}
          setOpenAssociatePopup={setOpenAssociatePopup}
          activeAssociateId={id}
          panLength={panNumber.length}
        />
      </div>
    </div>
  );
};

export default FieldForceAccountPanDetails;
